"use strict";
(() => {
  if (document.documentElement.dataset.bpProductLayoutMounted) return;
  document.documentElement.dataset.bpProductLayoutMounted = "true";
  let headerSections = [];
  const updateHeaderHeight = () => {
    const height = headerSections.reduce((total, section) => total + section.getBoundingClientRect().height, 0);
    document.documentElement.style.setProperty("--bp-product-header-height", `${Math.ceil(height)}px`);
  };
  const observer = typeof ResizeObserver === "function" ? new ResizeObserver(updateHeaderHeight) : null;
  const watchHeader = () => {
    observer?.disconnect();
    headerSections = [...document.querySelectorAll(".shopify-section-group-header-group")];
    if (!headerSections.length) {
      const header = document.querySelector("[data-site-header]");
      if (header) headerSections = [header];
    }
    headerSections.forEach(section => observer?.observe(section));
    updateHeaderHeight();
  };
  watchHeader();
  window.addEventListener("resize", updateHeaderHeight, { passive: true });
  document.addEventListener("shopify:section:load", watchHeader);
})();
